import { useMemo } from 'react';
import { useToken } from '@chakra-ui/react';
import type { CustomIconProps } from '../types';

const Print = ({
    width,
    height,
    color = 'currentColor',
    dataTestId,
    ...props
}: CustomIconProps): JSX.Element => {
    const [tokenColor] = useToken('colors', [color], [color]);
    const resolvedColor = useMemo(() => tokenColor, [tokenColor]);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? '16'}
            height={height ?? '16'}
            viewBox="0 0 16 16"
            fill={resolvedColor}
            data-testid={dataTestId}
            {...props}
        >
            <path d="M11.6973 4H14.1543C15.1737 4.00026 16 4.89559 16 6V14H12.9189V16H3.07324V13.333H0V6C2.9731e-08 4.89559 0.826307 4.00026 1.8457 4H4.3125V0H11.6973V4ZM4.30762 13.333H4.30371V14.667H11.6885V10.667H4.30762V13.333ZM1.8457 5.33301C1.50604 5.33327 1.23047 5.63197 1.23047 6V12H3.07324V9.33301H12.9229V12.667H14.7695V6C14.7695 5.63197 14.494 5.33327 14.1543 5.33301H1.8457ZM5.54297 4H10.4668V1.33301H5.54297V4Z" />
        </svg>
    );
};

export default Print;
